import * as React from 'react';
import * as dumbbellBlue from '../../../lotties/daily_lesson/dumbbell_blue.json';
import * as dumbbellGreen from '../../../lotties/daily_lesson/dumbbell_green.json';
import * as dumbbellPink from '../../../lotties/daily_lesson/dumbbell_pink.json';
import * as dumbbellYellow from '../../../lotties/daily_lesson/dumbbell_yellow.json';
import { DailyLessonLottieIcon } from './daily_lesson_lottie_icon';
const ANIMATION_BY_COLOR = {
    green: dumbbellGreen,
    pink: dumbbellPink,
    yellow: dumbbellYellow,
    blue: dumbbellBlue,
};
export const DailyLessonDumbbellLottieIcon = ({ volumeColor, classObject }) => {
    return React.createElement(DailyLessonLottieIcon, { animationData: ANIMATION_BY_COLOR[volumeColor], classObject: classObject });
};
